import { useState } from "react";
import { toast } from "sonner";
import { Building2, RotateCcw } from "lucide-react";
import { HelpTip } from "@/components/HelpTip";
import { NumInput } from "@/components/NumInput";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export const clampPct = (v) => Math.min(100, Math.max(0, Number(v) || 0));
const fmt = (v) => String(Number(v) || 0).replace(".", ",");

// Alíquota do mês (editável) + alíquota padrão da empresa (settings.tax_pct), salva via /auth/settings
export const TaxRateField = ({ value, onChange, testId = "dre-tax" }) => {
  const { user, updateSettings } = useAuth();
  const [saving, setSaving] = useState(false);
  const defaultPct = Number(user?.settings?.tax_pct) || 0;
  const monthPct = clampPct(value);
  const differs = Math.abs(monthPct - defaultPct) > 0.0001;

  const saveDefault = async () => {
    setSaving(true);
    try { await updateSettings({ settings: { tax_pct: monthPct } }); toast.success(`Alíquota padrão da empresa: ${fmt(monthPct)}% · novos meses já começam com ela`); }
    catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <div className="space-y-1.5" data-testid={`${testId}-field`}>
      <label className="text-sm font-medium flex items-center gap-2">Impostos (%) · este mês
        <HelpTip title="Alíquota de impostos" testId="help-tax-rate">Percentual descontado da receita bruta. Ajuste livremente de 0% a 100%, com decimais. Referências: MEI paga DAS fixo → use 0%; Simples Nacional varia por faixa de faturamento (Anexo I: 4%, 7,3%, 9,5%, 10,7%, 14,3%, 19%); Lucro Presumido ~ 5,93% a 16,33%. A alíquota deste mês não altera o padrão da empresa.</HelpTip>
      </label>
      <NumInput min="0" max="100" step="0.01" className="num" value={value} onChange={onChange} onBlur={() => onChange({ target: { value: String(monthPct) } })} placeholder="Ex.: 4,5" data-testid={testId} />
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-muted-foreground" data-testid={`${testId}-default-row`}>
        <span className="flex items-center gap-1"><Building2 className="w-3 h-3" />Padrão da empresa: <span className="num font-semibold text-foreground" data-testid={`${testId}-default-value`}>{fmt(defaultPct)}%</span></span>
        {differs && <Button type="button" size="sm" variant="ghost" className="h-6 px-1.5 text-[11px]" onClick={() => onChange({ target: { value: String(defaultPct) } })} data-testid={`${testId}-use-default`}><RotateCcw className="w-3 h-3 mr-1" />Usar padrão</Button>}
        {differs && <Button type="button" size="sm" variant="outline" className="h-6 px-2 text-[11px]" disabled={saving} onClick={saveDefault} data-testid={`${testId}-save-default`}>Salvar {fmt(monthPct)}% como padrão da empresa</Button>}
        {!differs && <span data-testid={`${testId}-same-as-default`}>· igual ao padrão</span>}
      </div>
    </div>
  );
};
